// extracted by mini-css-extract-plugin
export default {"filtersContainer":"ClientsTab_filtersContainer__WeJ0f","searchFilterWrapper":"ClientsTab_searchFilterWrapper__1uqpN","addButtonWrapper":"ClientsTab_addButtonWrapper__LkHWT"};